// React
import React from 'react';
import PropTypes from 'prop-types';
import VDSButtonGroup from '@visa/vds-react/button-group';

import buttonGroupStyle from './component.styles';

const ButtonGroup = ({ dataTest, children, direction, ...props }) => (
  <VDSButtonGroup
    data-test={`${dataTest}-cybsButtonGroup`}
    direction={direction}
    css={buttonGroupStyle}
    {...props}
  >
    {children}
  </VDSButtonGroup>
);

ButtonGroup.propTypes = {
  /**
   * dataTest string for testing.
   */
  dataTest: PropTypes.string.isRequired,

  /**
   * Two or more buttons
   */
  children: PropTypes.node.isRequired,

  /**
   * Direction
   */
  direction: PropTypes.oneOf(['reverse', 'right'])
};

ButtonGroup.defaultProps = { direction: '' };

ButtonGroup.displayName = 'ButtonGroup';

export default ButtonGroup;
